// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"btnWrapper___tErz1","handOff":"handOff___3rBuG","icon":"icon___YxDCP","ReactionBtn":"ReactionBtn___1Tujb","on":"on___2GvOV"};